import * as types from './types'

const actions = {
  setRangeFilterFromResponse ({ commit }, { index, ranges, previousRangeFilters }) {
    commit(types.SET_RANGE_INDEX, { index })
    ranges.forEach(({ type, from, to }) => {
      commit(types.SET_RANGE_ATTRIBUTE, { attribute: type, limitFrom: from, limitTo: to })
    })
  },
  setRangeFilter ({ commit }, { attribute, limitFrom, limitTo }) {
    commit(types.SET_RANGE_INDEX, { index })
    commit(types.SET_RANGE_ATTRIBUTE, { attribute })
    if (from != null) {
      commit(types.SET_RANGE_LIMIT_FROM, { attribute, limitFrom })
    }
    if (to != null) {
      commit(types.SET_RANGE_LIMIT_TO, { attribute, limitTo })
    }
  },
  setRangeFilterFromURL ({ commit }, { index, ranges }) {
    commit(types.SET_RANGE_INDEX, { index })
    ranges.forEach(({ type, from, to }) => {
      commit(types.SET_RANGE_ATTRIBUTE, { attribute: type, limitFrom: from, limitTo: to })
      commit(types.SET_RANGE_FROM_TO, { attribute: type, from, to })
    })
  },
  setRangeFilterFromTo ({ commit }, { attribute, from, to }) {
    commit(types.SET_RANGE_FROM_TO, { attribute, from, to })
  },
  removeRangeFilter ({ commit }, { attribute }) {
    commit(types.REMOVE_RANGE_FILTER, { attribute })
  },
  removeAllRangeFilters ({ commit }) {
    commit(types.REMOVE_ALL_RANGE_FILTERS)
  },
  resetState ({ commit }) {
    commit(types.RESET_STATE)
  }
}

export default actions
